import { LegalLayout } from "./LegalLayout";
import { SOCLOSE } from "../../constants/soclose";

const PRODUCT = "3DPrintForge";
const REFUND_WINDOW_DAYS = 14;

export function RefundPage() {
  return (
    <LegalLayout title="Refund Policy" updatedAt="2025-12-16">
      <p>
        This Refund Policy applies to purchases made on <strong>{PRODUCT}</strong>, operated by{" "}
        <strong>{SOCLOSE.name}</strong> ({SOCLOSE.uenLabel}, Singapore).
      </p>

      <h2>1. Refund window</h2>
      <p>
        We offer a <strong>{REFUND_WINDOW_DAYS}-day money-back guarantee</strong> from the date of your first paid charge
        on a new subscription. If you are not satisfied, contact us within this window for a full refund of that initial
        payment.
      </p>

      <h2>2. Conditions</h2>
      <ul>
        <li>The refund applies only to the first billing cycle of a new subscription.</li>
        <li>Refunds do not apply to renewals -- you may cancel a subscription anytime to stop future charges.</li>
        <li>Refunds do not apply to consumed credit packs, pay-as-you-go usage, or annual plans past the first 30 days.</li>
        <li>Accounts terminated for breach of the Terms of Service are not eligible.</li>
        <li>Fraudulent or duplicate refund requests will be denied.</li>
      </ul>

      <h2>3. How to request a refund</h2>
      <p>Email <a href={`mailto:${SOCLOSE.contact.email}`}>{SOCLOSE.contact.email}</a> from the address on your account with:</p>
      <ul>
        <li>Your account email and the date of purchase.</li>
        <li>The transaction reference (visible on your receipt).</li>
        <li>A short reason -- it helps us improve the product.</li>
      </ul>
      <p>We respond within 5 business days. Approved refunds are credited back to the original payment method within 5-10 business days, depending on your bank.</p>

      <h2>4. Cancellation</h2>
      <p>
        Cancelling a subscription stops all future charges. You retain access to the paid features until the end of the
        current billing period. There is no partial refund for the unused portion of the current period.
      </p>

      <h2>5. Currency</h2>
      <p>
        All prices and refunds are processed in <strong>{SOCLOSE.currency.code} ({SOCLOSE.currency.symbol})</strong>. If
        your card is in another currency, your bank may apply a conversion fee that is outside our control.
      </p>

      <h2>6. Statutory rights</h2>
      <p>Nothing in this policy limits any non-waivable statutory consumer rights you may have under applicable law.</p>

      <h2>7. Contact</h2>
      <address className="legal-address">
        {SOCLOSE.name}<br />
        {SOCLOSE.address.full}<br />
        <a href={`mailto:${SOCLOSE.contact.email}`}>{SOCLOSE.contact.email}</a>
      </address>
    </LegalLayout>
  );
}
